import { camelCase } from 'lib/utils/objectSerializer';
import { BankingDetailsAction } from './actions';
import { BankingDetailsState } from './types';

const initialState: BankingDetailsState = {
  isLoading: false,
  error: undefined,
  bankingDetails: undefined,
  transactionState: undefined,
};

export default function bankingDetailsReducer(
  state: BankingDetailsState = initialState,
  action: BankingDetailsAction,
) {
  switch (action.type) {
    case 'GET_BANKING_DETAILS_REQUEST': {
      return {
        ...state,
        isLoading: true,
        bankingDetails: initialState.bankingDetails,
      };
    }
    case 'GET_BANKING_DETAILS_FAILURE': {
      return {
        ...state,
        isLoading: false,
        bankingDetails: initialState.bankingDetails,
      };
    }
    case 'GET_BANKING_DETAILS_SUCCESS': {
      const { accountNumber, sortCode, accountName, bic, iban, localBankCode } =
        camelCase(action.payload);
      return {
        ...state,
        bankingDetails:
          Object.keys(action.payload).length === 0
            ? undefined
            : {
                accountNumber,
                sortCode,
                accountName,
                bic,
                iban,
                localBankCode,
              },
        error: undefined,
        isLoading: false,
      };
    }
    case 'GET_BANKING_DETAILS_TRANSACTION_STATE_REQUEST': {
      return {
        ...state,
        isLoading: true,
        transactionState: initialState.transactionState,
      };
    }
    case 'GET_BANKING_DETAILS_TRANSACTION_STATE_SUCCESS': {
      return {
        ...state,
        transactionState: action.payload?.status,
        isLoading: false,
      };
    }
    case 'GET_BANKING_DETAILS_TRANSACTION_STATE_FAILURE': {
      return {
        ...state,
        isLoading: false,
      };
    }

    default:
      return state;
  }
}
